import React, { Component } from "react";
import {
  Table,
  Input,
  Button,
  Card,
  Modal,
  message,
  Tag,
  Alert,
  Spin,
} from "antd";
import { connect } from "react-redux";
import {
  getDateYYYYMM,
  formateHHMMSSDate,
  timestampToTime,
  debounce,
} from "../../utils/dateUtil";
import { usrRole, _uuid } from "../../utils/dataUtil";
import axios from "axios";
import {
  req_list_pim_self,
  req_add_pim_bunchLog_in,
  req_add_pim_bunchLog_out,
  req_server_timestamp,
} from "../../api";
import BackFillSelfModal from "./back-fill-self-modal";
import OverTimeSelfModal from "./over-time-self-modal";

const { confirm } = Modal;
class ClockLogSelf extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    ip: "0.0.0.0",
    insideIPCheck: false,
    insertRow: {
      Uid: "",
      StaffCode: "",
      BunchDate: "",
      BunchTime: new Date(),
      BunchMessage: "SUCCESS",
      BunchStatus: "REALTIME",
      BunchType: "WEB",
      RecordIP: "0.0.0.0",
      NetworkStatus: "ALL",
      BackFillStatus: "NONE",
    },
    item: {},
    isShowBackFillModal: false,
    isShowOverTimeModal: false,
    antiShake: false,
  };
  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    this.api_server_time();
    this.fetchIP();
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_item_list();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_server_time = async () => {
    const server_time = await req_server_timestamp();
    // console.log()
    // console.log(new Date())
    return timestampToTime(server_time);
  };

  api_item_list = async () => {
    const { nowYearMonth } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true });
    const result = await req_list_pim_self(
      userLevel,
      userCode,
      nowYearMonth,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      //console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_add_item_bunchin = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_bunchLog_in(item, token);
    if (result.status === "success") {
      console.log(result);
      this.handle_data_refresh();
      message.success("已完成簽到");
    } else {
      message.error(result.message);
    }
  };

  api_add_item_bunchout = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_bunchLog_out(item, token);
    if (result.status === "success") {
      console.log(result);
      this.handle_data_refresh();
      message.success("已完成簽退");
    } else {
      message.error(result.message);
    }
  };

  // 格式轉換////////////////////////////////////////////////////
  // fetchIP = async () => {
  //   try {
  //     const response = await axios.get("https://api.ipify.org?format=json");
  //     this.setState({
  //       ip: response.data.ip,
  //       insideIPCheck: this.isIPInRange(response.data.ip),
  //     });
  //   } catch (error) {
  //     this.setState({ error: "Error fetching IP data" });
  //     console.error("Error fetching IP data:", error);
  //   }
  // };

  fetchIP = async () => {
    try {
      const response = await axios.get("https://ipinfo.io/json");
      this.setState({
        ip: response.data.ip,
        insideIPCheck: this.isIPInRange(response.data.ip),
      });
    } catch (error) {
      this.setState({ error: "Error fetching IP data" });
      console.error("Error fetching IP data:", error);
    }
  };

  ipToLong = (ip) => {
    return (
      ip
        .split(".")
        .reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0) >>> 0
    );
  };

  isIPInRange = (ip) => {
    if (ip === "0.0.0.0") return true; 

    const ipLong = this.ipToLong(ip);
    const range1Start = this.ipToLong("120.115.128.0");
    const range1End = this.ipToLong("120.115.223.255");
    const range2Start = this.ipToLong("192.192.3.0");
    const range2End = this.ipToLong("192.192.3.255");
    const range3Start = this.ipToLong("203.68.179.0");
    const range3End = this.ipToLong("203.68.185.255");

    return (
      (ipLong >= range1Start && ipLong <= range1End) ||
      (ipLong >= range2Start && ipLong <= range2End) ||
      (ipLong >= range3Start && ipLong <= range3End)
    );
  };

  extractTime(dateString) {
    const dateObject = new Date(dateString);
    const hours = dateObject.getHours().toString().padStart(2, "0");
    const minutes = dateObject.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  formatTime = (timeString) => {
    const [daysStr, hoursStr] = timeString.split(",");
    const days = parseInt(daysStr, 10);
    const hours = parseInt(hoursStr, 10);

    let result = [];

    if (days > 0) {
      result.push(`${days}天`);
    }
    if (hours > 0) {
      result.push(`${hours}小時`);
    }

    return result.join("");
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_show_ui_modal = (modal, item) => {
    const {
      ClockDate,
      ClockOutTimeMust,
      ClockInTimeMustReal,
      ClockOutTimeMustReal,
      BunchTimeFirst,
      Uid,
      takeLeaveTimeHours,
    } = item;
    const insertRow = this.state.insertRow;
    // console.log(item);
    switch (modal) {
      case "view":
        break;
      case "BackFill":
        this.setState({ item: item, isShowBackFillModal: true });
        break;
      case "BunchIn":
        this.api_server_time().then((time) => {
          const nowBunchInTime =
            new Date(time.replace("(台北標準時間)", "")).toString() ===
            "Invalid Date"
              ? new Date()
              : new Date(time.replace("(台北標準時間)", ""));
          const nowstandardInTime = new Date(ClockInTimeMustReal);
          if (nowBunchInTime < nowstandardInTime) {
            //早到
            //彈出提示
            confirm({
              title: "提前簽到", // Prompt message
              content:
                "依您本日標準作息簽到時間為 " +
                this.extractTime(nowstandardInTime) +
                "，若您現在 " +
                this.extractTime(nowBunchInTime) +
                "提早簽到，實際出勤初始時間，仍以標準作息簽到時間" +
                this.extractTime(nowstandardInTime) +
                "採計。仍欲簽到者請點選「確認」。",
              okText: "確認",
              cancelText: "取消",
              onOk: () => {
                if (this.state.antiShake) return;
                this.setState({ antiShake: true });
                this.bunchIn(item);
              },
              onCancel: () => {
                console.log("取消早到");
              },
            });
          } else {
            if (this.state.antiShake) return;
            this.setState({ antiShake: true });
            this.bunchIn(item);
          }
        });
        break;
      case "BunchOut":
        this.api_server_time().then((time) => {
          console.log("BunchOut");
          const currentTime =
            new Date(time.replace("(台北標準時間)", "")) || new Date();
          let standardInTime = new Date(ClockInTimeMustReal); // 標準簽到時間
          const WorkMinute = 8 * 60; // 學期標準工時8小時
          // const WorkMinute =
          //   ClockOutTimeMust === "1200" ? 3 * 60 + 30 : 6 * 60 + 30; // 寒暑假標準工時 3.5 小時 或 6.5 小時
          const NoonRestMinute = 1 * 60; // 中午休息1小時
          const NightRestMinute = ClockOutTimeMust === "1200" ? 0 : 30; // 未到1700則夜間休息0分，反之為30分鐘
          const OverTimeMinute = 1; //最低加班1分
          let overworkTime = new Date();
          let alertTime = new Date();
          //let tempTime = new Date();
          console.log("標準簽到時間：", standardInTime);
          if (BunchTimeFirst == null) {
            //無簽到
            if (standardInTime.getHours() < 12) {
              //白日班
              standardInTime.setMinutes(
                standardInTime.getMinutes() +
                  WorkMinute +
                  NoonRestMinute +
                  NightRestMinute +
                  OverTimeMinute
              );
              alertTime = new Date(ClockOutTimeMustReal);
              // console.log("白日班");
            } else {
              // 午夜班
              standardInTime.setMinutes(
                standardInTime.getMinutes() +
                  WorkMinute +
                  NightRestMinute +
                  OverTimeMinute
              );
              alertTime = new Date(ClockOutTimeMustReal);
              // console.log("午夜班");
            }
            overworkTime = standardInTime;
            //console.log("未簽到-超時標準時間計算：", overworkTime);
          } else {
            //有簽到
            let bunchTimeFirst = new Date(BunchTimeFirst);
            let realInTime = new Date(BunchTimeFirst); //實際簽到時間
            let tempInTime = new Date(BunchTimeFirst); //計算簽退時間
            console.log("實際簽到時間：", realInTime);
            if (realInTime < standardInTime) {
              //提早簽到
              if (standardInTime.getHours() < 12) {
                //白日班
                standardInTime.setMinutes(
                  standardInTime.getMinutes() +
                    WorkMinute +
                    NoonRestMinute +
                    NightRestMinute +
                    OverTimeMinute
                );
                alertTime = new Date(ClockOutTimeMustReal);
              } else {
                // 午夜班
                standardInTime.setMinutes(
                  standardInTime.getMinutes() +
                    WorkMinute +
                    NightRestMinute +
                    OverTimeMinute
                );
                alertTime = new Date(ClockOutTimeMustReal);
              }
              overworkTime = standardInTime;
              console.log("提早簽退-超時標準時間計算：", overworkTime);
            } else {
              //超過標準簽到
              if (takeLeaveTimeHours == null) {
                // 未請假(部分時數)，用實際時間來計算
                if (standardInTime.getHours() < 12) {
                  //白日班
                  realInTime.setMinutes(
                    realInTime.getMinutes() +
                      WorkMinute +
                      NoonRestMinute +
                      NightRestMinute +
                      OverTimeMinute
                  );
                  if (bunchTimeFirst.getHours() < 12) {
                    tempInTime.setMinutes(
                      tempInTime.getMinutes() + WorkMinute + NoonRestMinute
                    );
                    alertTime = new Date(tempInTime);
                  } else {
                    alertTime = new Date(ClockOutTimeMustReal);
                  }
                } else {
                  // 午夜班
                  realInTime.setMinutes(
                    realInTime.getMinutes() +
                      WorkMinute +
                      NightRestMinute +
                      OverTimeMinute
                  );
                  alertTime = new Date(ClockOutTimeMustReal);
                }
                overworkTime = realInTime;
              } else {
                // 有請假(部分時數)，用標準時間來計算
                if (standardInTime.getHours() < 12) {
                  //白日班
                  standardInTime.setMinutes(
                    standardInTime.getMinutes() +
                      WorkMinute +
                      NoonRestMinute +
                      NightRestMinute +
                      OverTimeMinute
                  );
                  alertTime = new Date(ClockOutTimeMustReal);
                } else {
                  // 午夜班
                  standardInTime.setMinutes(
                    standardInTime.getMinutes() +
                      WorkMinute +
                      NightRestMinute +
                      OverTimeMinute
                  );
                  alertTime = new Date(ClockOutTimeMustReal);
                }
                overworkTime = standardInTime;
              }
              console.log("超過標準簽退-超時標準時間計算：", overworkTime);
            }
          }
          console.log("現在時間：", currentTime);
          console.log("超時標準：", overworkTime);
          console.log(currentTime > overworkTime);

          if (currentTime > overworkTime) {
            // 要詢問是否要加班
            // const bunchTimeFirst = new Date(BunchTimeFirst);
            // const hoursDifference = Math.floor(
            //   (currentTime - bunchTimeFirst) / (1000 * 60 * 60)
            // );
            // console.log(hoursDifference);
            // if (hoursDifference > 1) {
            this.setState({ item: item, isShowOverTimeModal: true });
            // } else {
            // 直接簽退
            // insertRow.Uid = _uuid();
            // insertRow.BunchDate = ClockDate;
            // insertRow.BackFillStatus = "NONE";
            // //insertRow.BunchTime = new Date();
            // insertRow.StaffCode = this.props.user.userCode;
            // insertRow.RecordIP = this.state.ip;
            // this.api_add_item_bunchout(insertRow);
            // }
          } else {
            if (alertTime <= currentTime) {
              //滿足彈班
              //直接簽退
              insertRow.Uid = _uuid();
              insertRow.BunchDate = ClockDate;
              //insertRow.BunchTime = new Date();
              insertRow.StaffCode = this.props.user.userCode;
              insertRow.RecordIP = this.state.ip;
              this.api_add_item_bunchout(insertRow);
            } else {
              //詢問是否想早退
              confirm({
                title: "簽退提示", // Prompt message
                content:
                  "依您今日簽到時間，本日滿足標準工時簽退時間應為 " +
                  this.extractTime(alertTime) +
                  "，若您有日內請假或為彈性班表者，可依規劃時間簽退。仍欲簽退者請點選「確認」。",
                okText: "確認",
                cancelText: "取消",
                onOk: () => {
                  // Handle early sign-out confirmation
                  insertRow.Uid = _uuid();
                  insertRow.BunchDate = ClockDate;
                  //insertRow.BunchTime = new Date();
                  insertRow.StaffCode = this.props.user.userCode;
                  insertRow.RecordIP = this.state.ip;
                  this.api_add_item_bunchout(insertRow);
                },
                onCancel: () => {
                  console.log("取消簽退");
                },
              });
            }
          }
        });
        break;
      case "delete":
        Modal.confirm({
          title: `您確定刪除此筆`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_data_refresh = () => {
    this.api_item_list();
  };

  bunchIn = debounce((item) => {
    const { ClockDate } = item;
    const insertRow = this.state.insertRow;
    // 執行操作...
    //console.log(item);
    console.log("BunchIn");
    insertRow.Uid = _uuid();
    insertRow.BunchDate = ClockDate;
    insertRow.BackFillStatus = "NONE";
    //insertRow.BunchTime = new Date();
    insertRow.StaffCode = this.props.user.userCode;
    insertRow.RecordIP = this.state.ip;
    this.api_add_item_bunchin(insertRow);
  }, 2000);

  // 數據配置設定 //////////////////////////////////////////////
  init_columns = () => {
    const { antiShake } = this.state;
    this.columns = [
      {
        title: "操作",
        width: "50px",
        align: "center",
        fixed: "true",
        render: (item) => {
          const { insideIPCheck } = this.state;
          const {
            WorkStatus,
            BunchTimeLast,
            BunchTimeFirst,
            takeLeaveType,
            takeLeaveTimeHours,
            DiffDays,
            RetroactiveStatus,
            SignOutTag,
          } = item;
          return (
            <>
              {takeLeaveType != null &&
              this.formatTime(takeLeaveTimeHours) === "1天" ? (
                ""
              ) : (
                <>
                  {DiffDays > 0 ? (
                    <>
                      {WorkStatus === "PASS" ? (
                        ""
                      ) : (
                        <>
                          {BunchTimeLast !== null ? (
                            ""
                          ) : (
                            <>
                              {SignOutTag === "HIDDEN" ? (
                                ""
                              ) : (
                                <button
                                  className="btn btn-info btn-sm"
                                  disabled={
                                    RetroactiveStatus === "OPEN" ? false : true
                                  }
                                  onClick={() =>
                                    this.handle_show_ui_modal("BackFill", item)
                                  }
                                >
                                  <i className="fas fa-file-signature"></i> 補簽
                                </button>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {" "}
                      {insideIPCheck ? (
                        <>
                          {WorkStatus === "PASS" ? (
                            ""
                          ) : (
                            <>
                              {BunchTimeFirst !== null ? (
                                <button
                                  className="btn btn-success btn-md"
                                  style={{
                                    marginRight: "5px",
                                    minWidth: "70px",
                                  }}
                                  disabled={true}
                                >
                                  <i className="fas fa-sign-in-alt"></i> 簽到
                                </button>
                              ) : (
                                <button
                                  className={
                                    antiShake
                                      ? "btn btn-success btn-md"
                                      : "btn btn-warning btn-md"
                                  }
                                  style={{
                                    marginRight: "5px",
                                    minWidth: "70px",
                                  }}
                                  disabled={antiShake}
                                  onClick={() =>
                                    this.handle_show_ui_modal("BunchIn", item)
                                  }
                                >
                                  <i className="fas fa-sign-in-alt"></i> 簽到
                                </button>
                              )}
                              {""}
                              <button
                                className={
                                  BunchTimeLast !== null
                                    ? "btn btn-success btn-md"
                                    : "btn btn-warning btn-md"
                                }
                                style={{ minWidth: "70px" }}
                                disabled={BunchTimeLast !== null}
                                onClick={() =>
                                  this.handle_show_ui_modal("BunchOut", item)
                                }
                              >
                                <i className="fas fa-sign-out-alt"></i> 簽退
                              </button>
                            </>
                          )}
                        </>
                      ) : (
                        "非校內IP不能簽到退"
                      )}
                    </>
                  )}
                </>
              )}
            </>
          );
        },
      },
      {
        title: "日期",
        width: "50px",
        align: "center",
        fixed: "true",
        render: (item) => {
          const { ClockDate, WeekdayName, WorkStatus } = item;
          return (
            <>
              <span
                style={{
                  fontWeight: 900,
                  fontSize: "1.2em",
                  color: WorkStatus === "PASS" ? "#B22222" : "#483D8B",
                }}
              >
                {ClockDate}
                {WeekdayName}
              </span>
            </>
          );
        },
      },
      {
        title: "日期類型",
        width: "50px",
        align: "center",
        responsive: ["md"],
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                color: record.WorkStatus === "WORK" ? "#483D8B" : "#B22222",
                backgroundColor:
                  record.WorkStatus === "WORK" ? "#FFFFFF" : "#DCDCDC",
              },
            },
            children: (
              <div>
                {record.WorkReason}{" "}
                {record.ClockType === "FLEXIBLE" ? (
                  <Tag color="blue">彈</Tag>
                ) : (
                  ""
                )}
                {record.ClockType === "OVERTIME" ? (
                  <Tag color="red">加</Tag>
                ) : (
                  ""
                )}
              </div>
            ),
          };
        },
      },
      {
        title: "作息標準",
        width: "30px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { WorkStatus, ClockOutTimeMust, ClockInTimeMust } = item;
          return (
            <>
              {WorkStatus === "WORK" ? (
                <span
                  style={{ color: "green", fontWeight: 500, fontSize: "0.9em" }}
                >
                  {ClockInTimeMust}-{ClockOutTimeMust}
                </span>
              ) : (
                ""
              )}
            </>
          );
        },
      },
      {
        title: "簽到退時間",
        width: 40,
        align: "center",
        render: (item) => {
          const {
            BunchTimeFirst,
            BunchTimeLast,
            BackFillStatusFirst,
            BackFillStatusLast,
          } = item;
          return (
            <span style={{ fontWeight: 900, fontSize: "1.2em" }}>
              {BunchTimeFirst != null ? (
                <>
                  {formateHHMMSSDate(BunchTimeFirst)}
                  {BackFillStatusFirst === "NONE" ? (
                    ""
                  ) : (
                    <Tag color="volcano" style={{ marginLeft: "5px" }}>
                      補
                    </Tag>
                  )}
                </>
              ) : (
                ""
              )}
              {BunchTimeLast != null ? (
                <>
                  <>-</>
                  {formateHHMMSSDate(BunchTimeLast)}
                  {BackFillStatusLast === "NONE" ? (
                    ""
                  ) : (
                    <Tag color="volcano" style={{ marginLeft: "5px" }}>
                      補
                    </Tag>
                  )}
                </>
              ) : (
                ""
              )}
            </span>
          );
        },
      },
      // {
      //   title: "部門",
      //   width: "150px",
      //   align: "center",
      //   responsive: ["md"],
      //   render: (item) => {
      //     const { UnitName } = item;
      //     return <span style={{ fontWeight: 900 }}>{UnitName}</span>;
      //   },
      // },
      {
        title: "姓名",
        width: "50px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { StaffName } = item;
          return <span style={{ fontWeight: 900 }}>{StaffName}</span>;
        },
      },
      {
        title: "備註",
        width: 40,
        render: (item) => {
          const { takeLeaveType, takeLeaveTimeHours } = item;
          return (
            <span>
              {takeLeaveType != null ? takeLeaveType : ""}
              {takeLeaveType != null ? this.formatTime(takeLeaveTimeHours) : ""}
            </span>
          );
        },
      },
    ];
  };

  // 渲染頁面 //////////////////////////////////////////////
  render() {
    const {
      data,
      loading,
      nowYearMonth,
      ip,
      //insideIPCheck,
      isShowBackFillModal,
      isShowOverTimeModal,
      item,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="年月"
          style={{ width: 100, margin: "0 5px" }}
          value={nowYearMonth}
          onChange={(event) =>
            this.setState({ nowYearMonth: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>{" "}
      </>
    );
    return (
      <Card>
        {title}
        {data.length === 0 ? (
          <div style={{ marginTop: "10px", marginBottom: "10px" }}>
            {loading ? (
              <>
                {" "}
                <Spin tip="載入個人簽到退紀錄...">
                  <Alert message="" description="." type="info" />
                </Spin>
              </>
            ) : (
              <>
                {" "}
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <Alert
                    message="系統暫時無法接收及查詢資料，若要進行簽到退，請按下列按鈕登載"
                    type="success"
                  />
                </div>
                <div style={{ textAlign: "center" }}>
                  {" "}
                  <a
                    href="https://forms.gle/rxK5pETqf3v66HXY8"
                    target="_blank"
                    className="btn btn-success"
                    rel="noreferrer"
                  >
                    職工臨時簽到退單
                  </a>
                </div>
              </>
            )}
          </div>
        ) : (
          <>
            <Table
              bordered
              columns={this.columns}
              dataSource={data}
              pagination={false}
              loading={loading}
            />
          </>
        )}

        <Modal
          destroyOnClose={true}
          visible={isShowBackFillModal}
          width={250}
          onOk={() => {
            this.setState({ isShowBackFillModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowBackFillModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <BackFillSelfModal data={item} ip={ip} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowOverTimeModal}
          width={400}
          onOk={() => {
            this.setState({ isShowOverTimeModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowOverTimeModal: false });
            this.handle_data_refresh();
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OverTimeSelfModal
            data={item}
            ip={ip}
            onSuccess={() => {
              this.setState({ isShowOverTimeModal: false });
              this.handle_data_refresh();
            }}
          />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(ClockLogSelf);
